import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import { useParams } from 'react-router-dom';
import StudentResource from './StudentResource';


export const Resources = () => {
    const params = useParams()

    return (
        <>
            <RoutingMenu activeScreen="userResource" />
            <div className=''>
                {/* <iframe
                    src={`${config.RootUrl}/faculty/library/view/resources/resourcesList.php?isIframe=true&type=${params.id}`}
                    className="iframe col-md-12" >
                </iframe> */}
                {
                    config.account == "faculty" ?
                        <iframe
                            src={`${config.RootUrl}/faculty/library/view/resources/resourcesList.php?isIframe=true&type=${params.id}`}
                            className="iframe col-md-12" >
                        </iframe>
                        :
                        <StudentResource type={params.id}/>
                        // <iframe
                        //     src={`${config.RootUrl}/student/library/view/resources/resourcesList.php?isIframe=true&type=${params.id}`}
                        //     className="iframe col-md-12" >
                        // </iframe>
                }

            </div>
        </>
    )
}
